import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  loginFailed: {
    id: 'react-components.nuWwea',
    defaultMessage: 'Login failed',
  },
  emailLabel: {
    id: 'react-components.sy+pv5',
    defaultMessage: 'Email',
  },
  emailInvalid: {
    id: 'react-components.jv0FOj',
    defaultMessage: 'This must be a valid email address',
  },
  emailRequired: {
    id: 'react-components.KssJcX',
    defaultMessage: 'An email address is required',
  },
  passwordLabel: {
    id: 'react-components.5sg7KC',
    defaultMessage: 'Password',
  },
  passwordRequired: {
    id: 'react-components.Stbi1f',
    defaultMessage: 'A password is required',
  },
  loginButton: {
    id: 'react-components.AyGauy',
    defaultMessage: 'Login',
  },
  registerLink: {
    id: 'react-components.3VCFQV',
    defaultMessage: 'Register a new account',
  },
  forgotPasswordLink: {
    id: 'react-components.cyRU1N',
    defaultMessage: 'Forgot your password?',
  },
});
